(function () {
  const header = () => {
    const body = document.querySelector("body");
    const header = document.querySelector(".shopify-section-header");
    const headerDetails = document.querySelector(".menu-drawer-container");
    const headerIsAlwaysSticky =
      header
        .querySelector(".header-wrapper")
        .getAttribute("data-sticky-type") === "always";

    headerDetails.addEventListener("toggle", function (e) {
      const colorScheme =
        this.querySelector("#menu-drawer").dataset.colorScheme;
      header.classList.toggle(colorScheme);
    });

    document.addEventListener("keyup", (e) => {
      if (e.key === "Escape") {
        header.classList.remove("shopify-section-header-sticky", "animate");
        body.classList.remove("overflow-hidden");
      }
    });

    document.addEventListener("scroll", () => {
      let scrollTop = window.scrollY;
      if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
        header.classList.add("fixed", "animate");
      } else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
        header.classList.remove("fixed", "animate");
      }
    });
  };

  document.addEventListener("shopify:section:load", header);

  header();

  // When child menu items extend beyond the container, need to change the childmenue opening direction.
  const headerSubMenu = () => {
    const dir = document.querySelector("html").getAttribute("dir");
    const listMenu = document.querySelector(".header__menu .list-menu");
    const listMenuRect = listMenu.getBoundingClientRect();

    const allSubmenus = listMenu.querySelectorAll(
      ".header__submenu .list-menu-has-child .header__submenu"
    );
    allSubmenus.forEach((item) => {
      const itemRect = item.getBoundingClientRect();
      if (dir === "ltr") {
        if (itemRect.right > listMenuRect.right) {
          item.style.left = "auto";
          item.style.right = "100%";
        }
      } else {
        if (itemRect.left < listMenuRect.left) {
          item.style.left = "100%";
          item.style.right = "auto";
        }
      }
    });
  };

  headerSubMenu();

  // Accessible keyboard controls for top-level header dropdowns
  const accessibleHeaderMenus = () => {
    const menu = document.querySelector(".header__menu");
    if (!menu) return;

    const toggles = menu.querySelectorAll(".js-menu-toggle");
    if (!toggles.length) return;

    const closeAll = () => {
      toggles.forEach((toggle) =>
        toggle.setAttribute("aria-expanded", "false")
      );
    };

    const getSubmenu = (toggle) => {
      const controlsId = toggle.getAttribute("aria-controls");
      return controlsId ? document.getElementById(controlsId) : null;
    };

    const openAndFocusFirst = (toggle) => {
      closeAll();
      toggle.setAttribute("aria-expanded", "true");
      const submenu = getSubmenu(toggle);
      const firstFocusable =
        submenu &&
        submenu.querySelector(
          "a[href],button:not([disabled]),summary,[tabindex]:not([tabindex='-1'])"
        );
      if (firstFocusable instanceof HTMLElement) firstFocusable.focus();
    };

    const getOpenToggleFor = (element) => {
      const item = element.closest(".list-menu--inline > li");
      const toggle = item && item.querySelector(":scope > .js-menu-toggle");
      return toggle && toggle.getAttribute("aria-expanded") === "true"
        ? toggle
        : null;
    };

    // Enter keeps native link behaviour so the trigger's own destination stays
    // reachable; Space / ArrowDown open the submenu instead.
    menu.addEventListener("keydown", (e) => {
      const target = e.target;
      if (!(target instanceof HTMLElement)) return;

      if (e.key === "Escape") {
        const openToggle = getOpenToggleFor(target);
        if (!openToggle) return;
        e.preventDefault();
        openToggle.setAttribute("aria-expanded", "false");
        openToggle.focus();
        return;
      }

      if (!target.classList.contains("js-menu-toggle")) return;
      const isOpen = target.getAttribute("aria-expanded") === "true";

      if (e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        if (isOpen) {
          target.setAttribute("aria-expanded", "false");
        } else {
          openAndFocusFirst(target);
        }
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        openAndFocusFirst(target);
      } else if (e.key === "ArrowUp" && isOpen) {
        e.preventDefault();
        target.setAttribute("aria-expanded", "false");
      }
    });

    menu.addEventListener("focusout", (e) => {
      const item =
        e.target instanceof HTMLElement &&
        e.target.closest(".list-menu--inline > li");
      if (!item || (e.relatedTarget && item.contains(e.relatedTarget))) return;
      const toggle = item.querySelector(":scope > .js-menu-toggle");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    });

    document.addEventListener("click", (e) => {
      if (!menu.contains(e.target)) {
        closeAll();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !menu.contains(e.target)) {
        closeAll();
      }
    });
  };

  accessibleHeaderMenus();
})();
